import posthog from "posthog-js";
import type { Mutation } from "@tanstack/react-query";

export interface TrackingMeta {
  track?: boolean;
  eventName?: string;
  properties?: Record<string, unknown>;
  getProperties?: (
    variables: unknown,
    data: unknown,
  ) => Record<string, unknown>;
}

export function handleMutationSuccess(
  data: unknown,
  variables: unknown,
  _context: unknown,
  mutation: Mutation<unknown, unknown, unknown, unknown>,
  _mutationContext?: unknown,
): void {
  const meta = mutation.options.meta as TrackingMeta | undefined;
  if (!meta?.track || !meta.eventName) return;

  const dynamicProps = meta.getProperties?.(variables, data) ?? {};
  posthog.capture(meta.eventName, { ...meta.properties, ...dynamicProps });
}
